/* BeadznThreadz journal: reading progress, "In this story" scroll-spy, copy link. */
(function () {
  if (window.__bzJournal) return;
  window.__bzJournal = true;

  function init() {
    const article = document.querySelector('[data-bz-journal-article]');
    if (!article) return;

    /* Reading progress */
    const bar = document.querySelector('[data-bz-jprogress]');
    const body = article.querySelector('.bz-jbody-text') || article;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (bar) {
          const rect = body.getBoundingClientRect();
          const total = rect.height - window.innerHeight * 0.5;
          const done = Math.min(Math.max(-rect.top + window.innerHeight * 0.25, 0), Math.max(total, 1));
          bar.style.transform = `scaleX(${(done / Math.max(total, 1)).toFixed(4)})`;
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Scroll-spy for the contents list */
    const sections = [...article.querySelectorAll('[data-bz-jsec]')];
    const links = [...document.querySelectorAll('[data-bz-toc-link]')];
    if (sections.length && links.length && 'IntersectionObserver' in window) {
      const setActive = (id) => {
        links.forEach((a) => {
          const on = a.getAttribute('href') === `#${id}`;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      };
      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible.length) setActive(visible[0].target.id);
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
      );
      sections.forEach((s) => io.observe(s));
      links.forEach((a) =>
        a.addEventListener('click', () => {
          const details = a.closest('details');
          if (details) details.removeAttribute('open');
        })
      );
    }

    /* Copy link */
    article.querySelectorAll('[data-bz-copy-link]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const url = btn.dataset.bzCopyLink;
        try {
          if (navigator.clipboard) await navigator.clipboard.writeText(url);
          else {
            const t = document.createElement('textarea');
            t.value = url;
            document.body.appendChild(t);
            t.select();
            document.execCommand('copy');
            t.remove();
          }
          if (window.BZ && window.BZ.toast) window.BZ.toast(btn.dataset.copied || 'Link copied');
          btn.classList.add('is-done');
          setTimeout(() => btn.classList.remove('is-done'), 1600);
        } catch (e) {}
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
